import React from 'react';


class ArticleAbout extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <div></div>
    );
  }
}


export default ArticleAbout;



/** WEBPACK FOOTER **
 ** ./src/modules/articles/components/ArticleAbout.js
 **/